import React, { FC, useMemo } from 'react';
import ApexChart, { Props as ApexChartProps } from 'react-apexcharts';

import { ZeroStateProps as InternalZeroStateProps, ZeroState } from '@modernloop/shared/components';
import { flatMap } from 'lodash';

/**
 * Data point always is x & y as per FE and BE data contract
 */
export interface DataPoint {
  x: number | string | null | undefined;
  y: number | null | undefined;
}

export type DataPoints = DataPoint[];

export interface SingleSeries {
  name?: string;
  type?: string;
  data: DataPoints;
}

export type Series = SingleSeries[];

export interface ZeroStateProps extends InternalZeroStateProps {
  children?: React.ReactNode;
  type: ApexChartProps['type'];
  series?: ApexChartProps['series'];
  height?: number;
}
export const ZeroStateWrapper: FC<ZeroStateProps> = ({ children, series, type, height, ...zeroState }) => {
  const isEmpty = useMemo(() => {
    if (series?.length) {
      if (type === 'pie') {
        const toComputeSeries = series as number[];
        return !toComputeSeries.find((value) => {
          return value !== 0;
        });
      }
      const allData = flatMap(series as Series, (value) => value.data);
      return !allData.find((value) => {
        return value.y !== 0;
      });
    }
    return true;
  }, [series, type]);

  if (isEmpty) {
    return (
      <div
        style={{
          minHeight: height && `${height}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ZeroState {...zeroState} />
      </div>
    );
  }

  return <>{children}</>;
};

const Chart: FC<ApexChartProps> = (props) => {
  return <ApexChart {...props} />;
};
export default Chart;
